import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text } from '@rtkwlf/fenrir-react';
import { faSpinnerThird } from '@rtkwlf/pro-regular-svg-icons/faSpinnerThird';
import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '@packages/hooks/use-media-query';

// TODO @mreyesvera AWN-318385 - combine SimpleLoader and Loader into one
export const SimpleLoader: React.FC = () => {
  const { t } = useTranslation('ui');
  const isReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  return (
    <>
      <FontAwesomeIcon icon={faSpinnerThird} spin={!isReducedMotion} />
      <Text>
        {t('loader.retrieving')} {t('loader.takeTime')}
      </Text>
    </>
  );
};
